import { Grid } from '@mui/material';
import { Cropper } from 'shell/components/shared/cropper';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { DocumentDeathFormVM } from 'civil-status/view-models/document-birth-form';
import { PageMode } from 'civil-status/view-models/page-mode';
import UploadFileForm from '../shared/upload-file';
import AnnotationForm from '../shared/annotation';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import DocumentDeathFormShared from '../shared/death-form';

interface DocumentDeathFormProps {
  values?: DocumentDeathFormVM;
  errors?: FormikErrors<DocumentDeathFormVM>;
  touched?: FormikTouched<DocumentDeathFormVM>;
  onChange: (
    key: keyof DocumentDeathFormVM,
    value: DocumentDeathFormVM[keyof DocumentDeathFormVM]
  ) => void;
  onChanges: (values: DocumentDeathFormVM) => void;
  mode: PageMode;
  setMode: (mode: PageMode) => void;
  type: string;
}

const DocumentDeathComponent = ({
  values,
  touched,
  errors,
  mode,
  onChange,
  onChanges,
  type,
  setMode,
}: DocumentDeathFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <UploadFileForm values={values} onChange={onChange} mode={mode} />
        {mode === PageMode.Detail || mode === PageMode.Edit ? (
          <>
            <DocumentDeathFormShared
              onChange={onChange}
              onChanges={onChanges}
              values={values}
              errors={errors}
              mode={mode}
              touched={touched}
            />
          </>
        ) : undefined}
        <AnnotationForm
          values={values}
          onChange={onChange}
          mode={mode}
          type={type}
          setMode={setMode}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <StickyDiv>
          <Cropper
            images={values?.uploadFile?.raw || []}
            disabled={!values?.uploadFile?.raw?.length}
            height={900}
          />
        </StickyDiv>
      </Grid>
    </Grid>
  );
};

DocumentDeathComponent.displayName = 'Document Death form component';

const DocumentDeathForm = memo(DocumentDeathComponent);

export default DocumentDeathForm;
